import {
  GET_ACCOUNTS_CREATED_PENDING, GET_ACCOUNTS_CREATED_SUCCESS, GET_ACCOUNTS_CREATED_ERROR,
  GET_CUMULATIVE_USER_COUNT_PENDING, GET_CUMULATIVE_USER_COUNT_SUCCESS, GET_CUMULATIVE_USER_COUNT_ERROR,
  GET_JOB_POSTS_CREATED_PENDING, GET_JOB_POSTS_CREATED_SUCCESS, GET_JOB_POSTS_CREATED_ERROR,
  GET_JOB_APPLICATION_COUNT_PENDING, GET_JOB_APPLICATION_COUNT_SUCCESS, GET_JOB_APPLICATION_COUNT_ERROR,
} from '../../actions/admin/metrics';

const initialState = {
    pending: false,
    createdAccounts: [],
    error: null
}

export function reducer(state = initialState, action) {
  switch(action.type) {
      case GET_ACCOUNTS_CREATED_PENDING:
          return {
              ...state,
              pending: true
          }
      case GET_ACCOUNTS_CREATED_SUCCESS:
          return {
              ...state,
              pending: false,
              accountsCreated: action.payload.metrics,
          }
      case GET_ACCOUNTS_CREATED_ERROR:
          return {
              ...state,
              pending: false,
              error: action.error
          }
      case GET_CUMULATIVE_USER_COUNT_PENDING:
          return {
              ...state,
              pending: true
          }
      case GET_CUMULATIVE_USER_COUNT_SUCCESS:
          return {
              ...state,
              pending: false,
              cumulativeUserCount: action.payload.metrics,
          }
      case GET_CUMULATIVE_USER_COUNT_ERROR:
          return {
              ...state,
              pending: false,
              error: action.error
          }
      case GET_JOB_APPLICATION_COUNT_PENDING:
          return {
              ...state,
              pending: true
          }
      case GET_JOB_APPLICATION_COUNT_SUCCESS:
          return {
              ...state,
              pending: false,
              jobApplicationCount: action.payload.metrics,
          }
      case GET_JOB_APPLICATION_COUNT_ERROR:
          return {
              ...state,
              pending: false,
              error: action.error
          }
      case GET_JOB_POSTS_CREATED_PENDING:
          return {
              ...state,
              pending: true
          }
      case GET_JOB_POSTS_CREATED_SUCCESS:
          return {
              ...state,
              pending: false,
              jobPostsCreated: action.payload.metrics,
          }
      case GET_JOB_POSTS_CREATED_ERROR:
          return {
              ...state,
              pending: false,
              error: action.error
          }
      default:
          return state;
    }
}

export const getAccountsCreated = state => state.admin.accountsCreated;
export const getAccountsCreatedPending = state => state.admin.pending;
export const getAccountsCreatedError = state => state.admin.error;
export const getCumulativeUserCount = state => state.admin.cumulativeUserCount;
export const getCumulativeUserCountPending = state => state.admin.pending;
export const getCumulativeUserCountError = state => state.admin.error;
export const getJobApplicationCount = state => state.admin.jobApplicationCount;
export const getJobApplicationCountPending = state => state.admin.pending;
export const getJobApplicationCountError = state => state.admin.error;
export const getJobPostsCreated = state => state.admin.jobPostsCreated;
export const getJobPostsCreatedPending = state => state.admin.pending;
export const getJobPostsCreatedError = state => state.admin.error;
